import type { RumEvent } from "@datadog/browser-rum";

/**
 * Drops the benign "ResizeObserver loop" browser warning (Chromium/Safari and
 * Firefox wording). Keep in sync with pro-web's `resize-observer-noise.util.ts`.
 */
const RESIZE_OBSERVER_NOISE_PATTERN =
  /resizeobserver loop (completed with undelivered notifications|limit exceeded)/i;

export function isResizeObserverNoise(
  event: RumEvent | null | undefined,
): boolean {
  if (event?.type !== "error") {
    return false;
  }

  return RESIZE_OBSERVER_NOISE_PATTERN.test(event.error?.message ?? "");
}
